import api from "./api";

const API_URL = import.meta.env.VITE_API_URL;

export enum AuditType {
  kodeSherpaGeneration = "103",
  kodeSherpaLogin = "104",
  kodeSherpaMessageSent = "105",
  kodeSherpaBeforeGeneration = "106",
  kodeSherpaSessionStart = "107",
  kodeSherpaSessionEnd = "108",
  userRegistrationConfirmation = "129", // registered in post signup AWS lambda
  kodeSherpaDownload = "111",
  kodeSherpaExportRemix = "114",
  kodeSherpaSignup = "119", // registered in post signup AWS lambda
  kodeSherpaGenerationError = "131",
  kodeSherpaSubscriptionStarted = "117",
  kodeSherpaSubscriptionCancelled = "118",
  kodeSherpaPaymentFailed = "121",
  kodeSherpaSubscriptionDowngrade = "123",
  kodeSherpaSubscriptionUpgrade = "124",
  kodeSherpaError = "115",
  userRegistrationConfirmationError = "130",
}

export enum AuditStatus {
  Success = "INFO",
  Error = "ERROR",
}

export interface EventAudit {
  event: string;
  eventDescription: string;
  eventLog: any;
}

export const generateAudit = async (
  eventType: AuditType,
  event: EventAudit
) => {
  try {
    const response = await api.post(
      `${API_URL}/kodesherpa/event/record-event `,
      {
        eventId: eventType,
        jsonInfo: event,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error generating audit event: ", error);
  }
};
